import { useState, type Dispatch, type SetStateAction } from 'react';

/**
 * Like useState, but resets to `initialValue` whenever `resetKey` changes.
 * Uses the derived-state-during-render pattern — no effects, no extra renders beyond
 * the one React already does when a parent causes key to change.
 */
export function useResetState<T>(
  initialValue: T,
  resetKey: unknown
): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState<T>(initialValue);
  const [prevKey, setPrevKey] = useState(resetKey);

  if (prevKey !== resetKey) {
    setPrevKey(resetKey);
    setState(initialValue);
  }

  return [state, setState];
}
